export const tMenuDesigner = [
  {
    author: "ahmed_fayyaz@outlook.com",
    key: "-MERhiQhxxarbPfBBENs",
    menuItems: [
      {
        displayToggle: "YES",
        menuCaption: "ORDERS",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "ORDERS",
        tableName: "deliveryRequest"
      },
      {
        displayToggle: "YES",
        menuCaption: "SOURCE SUPPLIR",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "SOURCE SUPPLIER",
        tableName: "sourceSupplier"
      },
      {
        displayToggle: "YES",
        menuCaption: "PURCHASE",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "PURCHASE",
        tableName: "purchase"
      },
      {
        displayToggle: "YES",
        menuCaption: "OPEN BAZAR",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "OPEN BAZAR",
        tableName: "openBazar"
      },
      {
        displayToggle: "YES",
        menuCaption: "MY SHOP",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "MY SHOP",
        tableName: "supplierShopItems"
      },
      {
        displayToggle: "YES",
        menuCaption: "SIGN OUT",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "SIGN OUT",
        tableName: "signout"
      }
    ],
    name: "SALESADMIN",
    updateDateTime: "Tue 11-08-20 6:56 pm"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    menuItems: [""],
    name: "PROMO",
    updateDateTime: "05/06/2020 05:45:20",
    key: "-M92REy6SD5mIWH8yvL6"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    key: "-M71UZqdToF1w_zhxVIC",
    menuItems: [
      {
        displayToggle: "YES",
        menuCaption: "BCS HOME",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "BCS HOME",
        tableName: "bcsHome"
      },
      {
        menuCaption: "DELIVERY REQUEST",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "DELIVERY REQUEST",
        tableName: "deliveryRequest"
      },
      {
        displayToggle: "YES",
        menuCaption: "SIGN OUT",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "SIGN OUT",
        tableName: "signout"
      }
    ],
    name: "ORDERADMIN",
    updateDateTime: "26/05/2020 12:24:27"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    key: "-M70och0B-89dvRhHbrd",
    menuItems: [
      {
        displayToggle: "YES",
        menuCaption: "BCS HOME",
        menuIcon: "fa fa-home",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "BCS HOME",
        tableName: "bcsHome"
      },
      {
        displayToggle: "YES",
        menuCaption: "SUPPLIER",
        menuIcon: "fa fa-tachometer",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "SUPPLIER",
        tableName: "dqr"
      },
      {
        menuCaption: "MY SHOP",
        menuIcon: "fa fa-check-circle",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "MY SHOP",
        tableName: "supplierShopItems"
      },
      {
        menuCaption: "PURCHASE",
        menuIcon: "fa fa-truck",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "PURCHASE",
        tableName: "purchase"
      },
      {
        menuCaption: "OPEN BAZAR",
        menuIcon: "fa fa-users",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "OPEN BAZAR",
        tableName: "openBazar"
      },
      {
        displayToggle: "YES",
        menuCaption: "SIGN OUT",
        menuIcon: "fa fa-sign-out",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "SIGN OUT",
        tableName: "signout"
      }
    ],
    name: "STOREADMIN",
    updateDateTime: "29/06/2020 10:54:39"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    key: "-M5ug25nl8d498px1OFz",
    menuItems: [
      {
        displayToggle: "YES",
        menuCaption: "BCS HOME",
        menuIcon: "fa fa-home",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "BCS HOME",
        tableName: "bcsHome"
      },
      {
        menuCaption: "DELIVERY REQUEST",
        menuIcon: "fa fa-shopping-cart",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "DELIVERY REQUEST",
        tableName: "deliveryRequest"
      },
      {
        menuCaption: "OPEN BAZAR",
        menuIcon: "fa fa-users",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "OPEN BAZAR",
        tableName: "openBazar"
      },
      {
        menuCaption: "SIGN OUT",
        menuIcon: "fa fa-sign-out",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "SIGN OUT",
        tableName: "signout"
      }
    ],
    name: "WORKER",
    updateDateTime: "15/06/2020 05:44:40"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    key: "-M5ug-ocMGBo5XVgszQA",
    menuItems: [
      {
        menuCaption: "DELIVERY REQUEST",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "DELIVERY REQUEST",
        tableName: "deliveryRequest"
      },
      {
        displayToggle: "YES",
        menuCaption: "SIGN OUT",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "SIGN OUT",
        tableName: "signout"
      }
    ],
    name: "GROCER",
    updateDateTime: "26/05/2020 12:32:58"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    key: "6",
    menuItems: [
      {
        menuCaption: "BCS HOME",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "BCS HOME",
        tableName: "bcsHome"
      },
      {
        displayToggle: "YES",
        menuCaption: "OPEN BAZAR",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "OPEN BAZAR",
        tableName: "openBazar"
      },
      {
        displayToggle: "YES",
        menuCaption: "DELIVERY REQUEST",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "DELIVERY REQUEST",
        tableName: "deliveryRequest"
      },
      {
        menuCaption: "PURCHASE",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "PURCHASE",
        tableName: "purchase"
      },
      {
        displayToggle: "YES",
        menuCaption: "INVENTORY",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "INVENTORY",
        tableName: "inventory"
      },
      {
        menuCaption: "SOURCE SUPPLIR",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "SOURCE SUPPLIER",
        tableName: "sourceSupplier"
      },
      {
        displayToggle: "YES",
        menuCaption: "MY SHOP",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "MY SHOP",
        tableName: "supplierShopItems"
      },
      {
        displayToggle: "YES",
        menuCaption: "USERS",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "USERS",
        tableName: "users"
      },
      {
        menuCaption: "APP PHOTOS",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "APP PHOTOS",
        tableName: "appPhotos"
      },
      {
        displayToggle: "YES",
        menuCaption: "CREATE FORM",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "CREATE FORM",
        tableName: "createTable"
      },
      {
        displayToggle: "YES",
        menuCaption: "LIST OF TABLES",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "LIST OF TABLES",
        tableName: "listOfTables"
      },
      {
        displayToggle: "YES",
        menuCaption: "CREATE MENU",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "CREATE MENU",
        tableName: "menuDesigner"
      },
      {
        displayToggle: "YES",
        menuCaption: "SIGN OUT",
        mobileRecLimit: "",
        recLimit: "",
        tableCaption: "SIGN OUT",
        tableName: "signout"
      }
    ],
    name: "SUPERADMIN",
    updateDateTime: "Tue 11-08-20 10:08 pm"
  }
];



// WEBPACK FOOTER //
// ./src/staticData/tMenuDesigner.js